import { logInfo } from "../utils/log";

/**
 * Checks if the provided regex pattern (as a string) matches any part of the HTML content.
 * @param regexPatternString - The regex pattern as a string.
 * @param htmlContent - The full HTML content of the webpage.
 * @returns A boolean indicating whether the regex pattern matches any part of the HTML content.
 */
export const isPatternInHtml = (
  regexPatternString: string,
  htmlContent: string
): boolean => {
  if (!regexPatternString || !htmlContent) {
    logInfo("Invalid input: regex pattern or HTML content is empty.");
    return false;
  }

  const regexPattern = new RegExp(regexPatternString, "i"); // 'i' flag for case-insensitive search

  return regexPattern.test(htmlContent);
};
